import { IsoMonth } from '@aloft/toolkit-shared';

export const toIsoMonth = (year: number, month: number): IsoMonth =>
  `${year}-${month.toString().padStart(2, '0')}` as IsoMonth;
